<div class="w-full flex flex-col pt-5 gap-md">
  <div class="flex justify-between items-center">
    <span class="text-4xl font-bold">{{ catalogItem.value()?.data?.name }}</span>
    <doka-button (click)="openTemplatesSlideOver()">
      {{ "MasterData.TemplatesGrid.NewTemplate" | i18nextEager }}
    </doka-button>
  </div>
  <doka-search-field (valueChange)="searchText.set($event)" [placeholder]="'Common.Search' | i18nextEager" />
  @if (templates.isLoading()) {
    <app-spinner />
  } @else if (filteredTemplates().length === 0) {
    <app-empty-state
      [message]="'EmptyState.NoTemplates'"
      [description]="'EmptyState.NoTemplatesDescription'"
      [icon]="'description'"
    />
  } @else {
    <doka-table>
      <doka-thead>
        <doka-tr>
          <doka-th>
            {{ "MasterData.TemplatesGrid.Country" | i18nextEager }}
          </doka-th>
          <doka-th>
            {{ "MasterData.TemplatesGrid.Cost" | i18nextEager }}
          </doka-th>
          <doka-th>
            {{ "MasterData.TemplatesGrid.Currency" | i18nextEager }}
          </doka-th>
          <doka-th>
            {{ "MasterData.TemplatesGrid.Lifetime" | i18nextEager }}
          </doka-th>
          <doka-th>
            {{ "MasterData.TemplatesGrid.EstimatedDelivery" | i18nextEager }}
          </doka-th>
        </doka-tr>
      </doka-thead>
      <doka-tbody>
        @for (template of filteredTemplates(); track template.id) {
          <doka-tr>
            <doka-td>{{ template.country }}</doka-td>
            <doka-td>{{ template.cost }}</doka-td>
            <doka-td>{{ template.isoCurrencyCode }}</doka-td>
            <doka-td>{{ template.lifetimeInMonths ?? "-" }}</doka-td>
            <doka-td>{{ template.estimatedDeliveryTime }}</doka-td>

            <doka-td>
              <div class="flex justify-end">
                <!-- <doka-button size="small" color="clear" icon="more_horiz" [iconOnly]="true" /> -->
                <doka-action-menu>
                  <doka-action-menu-item
                    icon="edit"
                    [text]="'Common.Edit' | i18nextEager"
                    (clicked)="openTemplatesSlideOver(template)"
                  />
                  <doka-action-menu-item
                    icon="delete"
                    [text]="'Common.Delete' | i18nextEager"
                    [alertStyle]="true"
                    (clicked)="openDeleteTemplateModal(template)"
                  />
                </doka-action-menu>
              </div>
            </doka-td>
          </doka-tr>
        }
      </doka-tbody>
    </doka-table>
  }
</div>
